// extracted by mini-css-extract-plugin
module.exports = {"colorPickerParentDiv":"ColorPicker_colorPickerParentDiv__mNA71","colorPickerDiv":"ColorPicker_colorPickerDiv__3hYz0"};